import { Divider, Input, Button, Menu } from "antd";
import _ from "lodash";
import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import { getVocabulary } from "./Vocabulary";

export const PAST_OPTIONS = [
  {
    label: "Overdue",
    value: "OVERDUE",
    startOffset: -20000,
    endOffset: 0,
  },
  {
    label: "Yesterday",
    value: "YESTERDAY",
    startOffset: -1,
    endOffset: -1,
  },
  {
    label: "Last 7 Days",
    value: "LAST_7_DAYS",
    startOffset: -7,
    endOffset: 0,
  },
  {
    label: "Last 15 Days",
    value: "LAST_15_DAYS",
    startOffset: -15,
    endOffset: 0,
  },
  {
    label: "Last 30 Days",
    value: "LAST_30_DAYS",
    startOffset: -30,
    endOffset: 0,
  },
  {
    label: "Last 90 Days",
    value: "LAST_90_DAYS",
    startOffset: -90,
    endOffset: 0,
  },
];

export const FUTURE_OPTIONS = [
  {
    label: "Today",
    value: "TODAY",
    startOffset: 0,
    endOffset: 0,
  },
  {
    label: "Next 7 Days",
    value: "NEXT_7_DAYS",
    startOffset: 0,
    endOffset: 7,
  },
  {
    label: "Next 15 Days",
    value: "NEXT_15_DAYS",
    startOffset: 0,
    endOffset: 15,
  },
  {
    label: "Next 30 Days",
    value: "NEXT_30_DAYS",
    startOffset: 0,
    endOffset: 30,
  },
  {
    label: "Next 90 Days",
    value: "NEXT_90_DAYS",
    startOffset: 0,
    endOffset:90,
  },
];

const ColumnFilterDueDate = React.memo(function ColumnFilterDueDate({
  selectedKeys,
  confirm,
  setSelectedKeys,
  visible,
}) {
  const [selected, setSelected] = useState(selectedKeys);

  useEffect(() => {
    if (visible) {
      setSelected(selectedKeys || []);
    }
  }, [selectedKeys, visible]);

  const applyFilter = useCallback(() => {
    setSelectedKeys(_.isEmpty(selected) ? [] : [...selected]);
    confirm();
  }, [setSelectedKeys, selected, confirm]);

  const clearFilter = useCallback(() => {
    setSelected([]);
  }, []);

  const onQuickOptionClick = useCallback(({ key }) => {
    setSelected([key]);
  }, []);

  const renderQuickOptions = (options) => {
    return (
      <Menu
        className="no-border"
        onClick={onQuickOptionClick}
        selectedKeys={isQuickOptionSelected ? selected : null}
      >
        {_.map(options, (option) => {
          return <Menu.Item key={option.value}>{option.label}</Menu.Item>;
        })}
      </Menu>
    );
  };

  const onPastInputChange = useCallback((e) => {
    const value = e.target.value;
    setSelected((prev) => [value, prev[1] || ""]);
  }, []);

  const onFutureInputChange = useCallback((e) => {
    const value = e.target.value;
    setSelected((prev) => {
      let first = prev[0] || "";
      if(isNaN(first)){
        first = "";
      }
      return [first, value]
    });
  }, []);

  const isQuickOptionSelected = _.size(selected) === 1 && _.isNaN(+selected[0]);
  return (
    <>
      <div className="due-date-column-filter">
        <div className="p-l">
          In this view, show findings which are
          <div className="d-flex p-t-xs">
            <div className="m-r-l d-flex">
              <div className="m-r-l">
                <strong>Past Due</strong>
                {/* {Object.values(quickOptions[0].pastDue).map(i => <div className="m-t-xs" onClick={() => applyFilter(i)}>{i}</div>)} */}
                {renderQuickOptions(PAST_OPTIONS)}
              </div>
              <div>
                <strong>Due In</strong>
                {renderQuickOptions(FUTURE_OPTIONS)}
                {/* {Object.values(quickOptions[0].dueIn).map((i) => (
                  <div className="m-t-xs" onClick={() => applyFilter(i)}>
                    {i}
                  </div>
                ))} */}
              </div>
            </div>
            <div className="m-t-l m-b-l">
              <Divider style={{ height: 60 }} type="vertical" />
              <div>Or</div>
              <Divider style={{ height: 60 }} type="vertical" />
            </div>
            <div className="m-l-l m-t-xs p-t-l">
              <Input.Group compact>
                <div>
                  <strong>Past Due</strong> &nbsp;
                  <Input
                    min={1}
                    max={999}
                    type="number"
                    style={{ width: 80 }}
                    id="searchTextGEQ"
                    value={!isQuickOptionSelected ? selected[0] : undefined}
                    onChange={onPastInputChange}
                  />
                  &nbsp;<strong>Days</strong>
                </div>
                <br />
                <div className="p-t-xs p-l-l" style={{ marginLeft: 60 }}>
                  &nbsp;Or
                  <br />
                  And
                </div>
                <br />
                <div className="m-t-xs">
                  <strong>Due In</strong> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <Input
                    min={1}
                    max={999}
                    type="number"
                    style={{ width: 80 }}
                    id="searchTextLEQ"
                    value={!isQuickOptionSelected ? selected[1] : undefined}
                    onChange={onFutureInputChange}
                  />
                  &nbsp;<strong>Days</strong>
                </div>
              </Input.Group>
            </div>
          </div>
          <div className="text-right">
            <Button className="m-r-xs" type="link" size="small" onClick={clearFilter}>
              Clear
            </Button>
            <Button type="primary" size="small" onClick={applyFilter}>
              Apply
            </Button>
          </div>
        </div>
      </div>
    </>
  );
});

export default ColumnFilterDueDate;


export function parseDueDateUIFilter(values){
  let startMoment, endMoment;
  let pastDue, dueIn;
  if(_.isArray(values) && _.size(values) > 0){
    if(_.size(values) === 1){
      let object = _.find(PAST_OPTIONS, { value: values[0] });
      if(object){
        const { startOffset, endOffset } = object;
        startMoment = moment().add(startOffset, "day").startOf("day");
        endMoment = moment().add(endOffset, "day");
        if(endOffset !== 0){
          endMoment = endMoment.endOf("day");
        }
        // return [];
      } else {
        object = _.find(FUTURE_OPTIONS, { value: values[0] });
        if (object) {
          const { startOffset, endOffset } = object;
          startMoment = moment().add(startOffset, "day");
          endMoment = moment().add(endOffset, "day").endOf("day");
          if (startOffset !== 0) {
            startMoment = startMoment.startOf("day");
          }
        }
      }
      if(!startMoment || !endMoment){
        console.warn(`Unknown values in ${getVocabulary("resolution")} Due Date filter - ${values}`);
      }
    } else {
      let [pastDueDay, dueInDay] = values;
      if(!pastDueDay){
        pastDueDay = 0;
      }
      if(!dueInDay){
        dueInDay = 0;
      }
      if (!_.isNaN(+pastDueDay)) {
        startMoment = moment().subtract(pastDueDay, "day");
        if(pastDueDay !== 0){
          startMoment = startMoment.startOf("day");
        }
        endMoment = moment().add(dueInDay, "day");
        if(dueInDay !== 0){
          endMoment = endMoment.endOf("day");
        }
      } else {
        pastDue = Math.abs(moment(pastDueDay).diff(moment(), "day"));
        dueIn = Math.abs(moment(dueInDay).diff(moment(), "day"));
      }
    }
  }
  if(!_.isUndefined(pastDue) && !_.isUndefined(dueIn)){
    if (pastDue === 0 && dueIn === 0) {
      return ["TODAY"];
    }
    if (pastDue === 1 && dueIn === 0) {
      return ["YESTERDAY"];
    }
    return [pastDue, dueIn];
  }
  if(startMoment && endMoment){
    return [startMoment.utc().format(), endMoment.utc().format()];
  }
  return [];
}

export function dueDateAllFilterFormatter(values){
  if(_.isArray(values) && _.size(values) > 0){
    if(_.size(values) === 1){
      const object = _.find([...PAST_OPTIONS, ...FUTURE_OPTIONS], { value: values[0] });
      if(object){
        return object.label;
      }
    } else {
      const texts = [];
      const [pastDueDay, dueInDay] = values;
      if(pastDueDay){
        texts.push(`Past Due ${pastDueDay} Day${pastDueDay > 1 ? "s" : ""}`)
      }
      if(dueInDay){
        texts.push(`Due In ${dueInDay} Day${dueInDay > 1 ? "s" : ""}`)
      }

      return texts.join(" - ");
    }
  }
  return values;
}